import React from "react";

export const WritingIcon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28px"
        height="28px"
        viewBox="0 0 32 32"
        version="1.1"
      >
        <g
          stroke="none"
          fillRule="evenodd"
          fill="none"
          fillOpacity="1"
          strokeWidth="1"
        >
          <g transform="translate(-223.000000, -55.000000)">
            <g id="writting" transform="translate(223.000000, 55.000000)">
              <rect
                fill="#1B6EC2"
                opacity="0.149999991"
                x="0"
                y="0"
                width="32"
                height="32"
                rx="16"
              ></rect>
              <path
                fill="#26A960"
                fillRule="nonzero"
                d="M20.8076923,9.01923077 C20.1370191,9.01923077 19.4543268,9.27644246 18.9423077,9.78846154 L13.2307692,15.5 L9.86538462,16.7884615 L9.53846154,16.9230769 L9.48076923,17.2692308 L8.61538462,23.0576923 L8.5,23.8846154 L9.32692308,23.7692308 L15.1153846,22.9038462 L15.4615385,22.8461538 L15.5961538,22.5192308 L16.8076923,19.3269231 L17.1153846,19.0384615 L22.6538462,13.5 C23.6466345,12.5072117 23.6658652,10.9134615 22.7307692,9.88461538 L22.6538462,9.78846154 C22.1418271,9.27644246 21.4783655,9.01923077 20.8076923,9.01923077 Z M20.8076923,10.2307692 C21.1538462,10.2307692 21.5,10.3846154 21.7884615,10.6730769 C22.3653846,11.25 22.3653846,12.0576923 21.7884615,12.6346154 L18.6923077,15.7307692 L16.7307692,13.7692308 L19.8269231,10.6730769 C20.1153846,10.3846154 20.4615385,10.2307692 20.8076923,10.2307692 Z M15.8461538,14.6538462 L17.8076923,16.6153846 L16.6923077,17.7307692 L14.7307692,15.7692308 L15.8461538,14.6538462 Z M13.7884615,16.5961538 L13.8076923,16.5961538 L15.7884615,18.5769231 L14.5769231,21.75 L10.9807692,22.2692308 L12.6346154,20.6153846 C12.6682695,20.6177883 12.6971157,20.6346154 12.7307692,20.6346154 C13.2740388,20.6346154 13.7307692,20.1971157 13.7307692,19.6538462 C13.7307692,19.1105772 13.2740388,18.6538462 12.7307692,18.6538462 C12.1875003,18.6538462 11.75,19.1105772 11.75,19.6538462 C11.75,19.6875003 11.7668271,19.7163465 11.7692308,19.75 L10.1153846,21.4038462 L10.6346154,17.8076923 L13.7884615,16.5961538 Z"
              ></path>
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};
